import React, { useState } from "react";
import {
  ScrollView,
  View,
  Text,
  Image,
  TouchableOpacity,
  TextInput,
  Modal,
  ActivityIndicator,
  Linking,
} from "react-native";
import MaskInput, { Masks } from "react-native-mask-input";
import BaseWeb from "./components/baseWeb";
import appConfig from "../app.json";

export default function PerfilWeb() {
  const [modalCampo, setModalCampo] = useState(null); // 'telefone' | 'email'
  const [modalSenha, setModalSenha] = useState(false);
  const [novoValor, setNovoValor] = useState("");
  const [loading, setLoading] = useState(false);
  const [mensagemCampo, setMensagemCampo] = useState("");
  const [mensagemSenha, setMensagemSenha] = useState("");
  const [senhaAtual, setSenhaAtual] = useState("");
  const [novaSenha, setNovaSenha] = useState("");
  const [confirmarSenha, setConfirmarSenha] = useState("");
  const [usuarioID, setUsuarioID] = useState(null);

  const fecharModais = () => {
    setModalCampo(null);
    setModalSenha(false);
    setMensagemCampo("");
    setMensagemSenha("");
    setSenhaAtual("");
    setNovaSenha("");
    setConfirmarSenha("");
    setNovoValor("");
  };

  const atualizarCampo = async (campo) => {
    if (!usuarioID) return;
    setLoading(true);
    try {
      const url = `https://api.imogo.com.br/api/v1/usuarios/corretor/${usuarioID}/${campo}?novo_${campo}=${encodeURIComponent(
        novoValor
      )}`;
      const response = await fetch(url, { method: "PUT" });
      const data = await response.json();
      setMensagemCampo(data.detail || "Atualizado com sucesso");
    } catch {
      setMensagemCampo("Erro ao atualizar o campo");
    } finally {
      setLoading(false);
    }
  };

  const atualizarSenha = async () => {
    if (!usuarioID || novaSenha !== confirmarSenha) {
      setMensagemSenha("As senhas não coincidem");
      return;
    }
    setLoading(true);
    try {
      const url = `https://api.imogo.com.br/api/v1/usuarios/corretor/${usuarioID}/senha?senha_antiga=${encodeURIComponent(
        senhaAtual
      )}&nova_senha=${encodeURIComponent(novaSenha)}`;
      const response = await fetch(url, { method: "PUT" });
      const data = await response.json();
      setMensagemSenha(data.detail || "Senha alterada com sucesso");
    } catch {
      setMensagemSenha("Erro ao atualizar senha");
    } finally {
      setLoading(false);
    }
  };

  const appVersion = appConfig.expo?.version || "";
  const appName = appConfig.expo?.name || "";

  return (
    <BaseWeb>
      {(userInfo) => {
        if (!usuarioID) setUsuarioID(userInfo?.id);

        return (
          <ScrollView
            contentContainerStyle={{
              flexGrow: 1,
              flexDirection: "row",
              padding: 40,
              backgroundColor: "#f5f5f5",
            }}
          >
            {/* Menu lateral */}
            <View
              style={{
                width: 260,
                paddingRight: 24,
                borderRightWidth: 1,
                borderColor: "#e5e7eb",
              }}
            >
              <View style={{ alignItems: "center", marginBottom: 24 }}>
                <Image
                  source={{
                    uri:
                      userInfo?.foto_conta ||
                      "https://juca.eu.org/img/icon_dafault.jpg",
                  }}
                  style={{ width: 80, height: 80, borderRadius: 40 }}
                />
                <Text
                  style={{ fontWeight: "bold", fontSize: 18, marginTop: 12 }}
                >
                  {userInfo?.nome_social}
                </Text>
                <Text style={{ color: "#6b7280", fontSize: 14 }}>
                  {userInfo?.email}
                </Text>
              </View>

              <TouchableOpacity style={{ paddingVertical: 10 }}>
                <Text style={{ color: "#730d83", fontWeight: "bold" }}>
                  Conta
                </Text>
              </TouchableOpacity>

              <TouchableOpacity
                style={{ paddingVertical: 10 }}
                onPress={() => {
                  Linking.openURL(
                    "https://sites.google.com/view/imogoapp/privacy-policy"
                  );
                }}
              >
                <Text style={{ color: "#6b7280", fontWeight: "bold" }}>
                  Política de Privacidade
                </Text>
              </TouchableOpacity>

              <TouchableOpacity
                style={{ paddingVertical: 10 }}
                onPress={() => {
                  Linking.openURL(
                    "https://sites.google.com/view/imogoapp/termos"
                  );
                }}
              >
                <Text style={{ color: "#6b7280", fontWeight: "bold" }}>
                  Termos e Condições
                </Text>
              </TouchableOpacity>
              <TouchableOpacity
                style={{ paddingVertical: 10 }}
                onPress={() => {
                  Linking.openURL(
                    "https://imogo.com.br/"
                  );
                }}
              >
                <Text style={{ color: "#6b7280", fontWeight: "bold" }}>
                  {appName} v{appVersion}
                </Text>
              </TouchableOpacity>
            </View>

            {/* Conteúdo principal */}
            <View style={{ flex: 1, paddingLeft: 40 }}>
              <Text
                style={{ fontSize: 24, fontWeight: "bold", marginBottom: 24 }}
              >
                Configurações da Conta
              </Text>

              {[
                {
                  label: "Telefone",
                  valor: userInfo?.telefone,
                  campo: "telefone",
                },
                { label: "E-mail", valor: userInfo?.email, campo: "email" },
              ].map(({ label, valor, campo }) => (
                <View key={campo} style={{ marginBottom: 24 }}>
                  <Text
                    style={{ fontSize: 14, fontWeight: "600", marginBottom: 4 }}
                  >
                    {label}
                  </Text>
                  <Text style={{ color: "#374151" }}>
                    {valor || "Não informado"}
                  </Text>
                  <TouchableOpacity
                    onPress={() => {
                      setNovoValor(valor);
                      setModalCampo(campo);
                      setMensagemCampo("");
                    }}
                  >
                    <Text
                      style={{
                        color: "#730d83",
                        fontWeight: "bold",
                        marginTop: 6,
                      }}
                    >
                      Editar {label}
                    </Text>
                  </TouchableOpacity>
                  <View
                    style={{
                      height: 1,
                      backgroundColor: "#E0E0E0",
                      width: "100%",
                      marginVertical: 12,
                    }}
                  />
                </View>
              ))}
              {/* Senha */}
              <View style={{ marginBottom: 20 }}>
                <Text
                  style={{ fontSize: 14, fontWeight: "600", marginBottom: 4 }}
                >
                  Senha
                </Text>
                <TouchableOpacity
                  onPress={() => {
                    setModalSenha(true);
                    setMensagemSenha("");
                  }}
                >
                  <Text
                    style={{
                      color: "#730d83",
                      fontWeight: "bold",
                      marginTop: 6,
                    }}
                  >
                    Alterar Senha
                  </Text>
                </TouchableOpacity>
              </View>
            </View>

            {/* Modal Campo */}
            <Modal visible={!!modalCampo} transparent animationType="fade">
              <View
                style={{
                  flex: 1,
                  justifyContent: "center",
                  alignItems: "center",
                  backgroundColor: "rgba(0,0,0,0.5)",
                }}
              >
                <View
                  style={{
                    backgroundColor: "white",
                    padding: 30,
                    borderRadius: 12,
                    width: "90%",
                    maxWidth: 400,
                  }}
                >
                  <Text
                    style={{
                      fontSize: 18,
                      fontWeight: "bold",
                      marginBottom: 10,
                    }}
                  >
                    Editar {modalCampo}
                  </Text>
                  {modalCampo === "telefone" ? (
                    <MaskInput
                      value={novoValor}
                      onChangeText={setNovoValor}
                      style={{
                        borderWidth: 1,
                        borderColor: "#ccc",
                        borderRadius: 6,
                        padding: 10,
                        marginBottom: 16,
                      }}
                      keyboardType="phone-pad"
                      mask={Masks.BRL_PHONE}
                    />
                  ) : (
                    <TextInput
                      value={novoValor}
                      onChangeText={setNovoValor}
                      keyboardType="email-address"
                      autoCapitalize="none"
                      style={{
                        borderWidth: 1,
                        borderColor: "#ccc",
                        borderRadius: 6,
                        padding: 10,
                        marginBottom: 16,
                      }}
                    />
                  )}
                  <TouchableOpacity
                    onPress={() => atualizarCampo(modalCampo)}
                    style={{
                      backgroundColor: "#730d83",
                      padding: 12,
                      borderRadius: 6,
                      alignItems: "center",
                      marginBottom: 10,
                    }}
                  >
                    <Text style={{ color: "#fff", fontWeight: "bold" }}>
                      Salvar
                    </Text>
                  </TouchableOpacity>
                  <TouchableOpacity
                    onPress={fecharModais}
                    style={{ alignItems: "center" }}
                  >
                    <Text style={{ color: "#aaa" }}>Cancelar</Text>
                  </TouchableOpacity>
                  {mensagemCampo ? (
                    <Text style={{ marginTop: 10, color: "green" }}>
                      {mensagemCampo}
                    </Text>
                  ) : null}
                </View>
              </View>
            </Modal>

            {/* Modal Senha */}
            <Modal visible={modalSenha} transparent animationType="fade">
              <View
                style={{
                  flex: 1,
                  justifyContent: "center",
                  alignItems: "center",
                  backgroundColor: "rgba(0,0,0,0.5)",
                }}
              >
                <View
                  style={{
                    backgroundColor: "white",
                    padding: 30,
                    borderRadius: 12,
                    width: "90%",
                    maxWidth: 400,
                  }}
                >
                  <Text
                    style={{
                      fontSize: 18,
                      fontWeight: "bold",
                      marginBottom: 10,
                    }}
                  >
                    Alterar Senha
                  </Text>

                  <TextInput
                    placeholder="Senha atual"
                    secureTextEntry
                    value={senhaAtual}
                    onChangeText={setSenhaAtual}
                    style={{
                      borderWidth: 1,
                      borderColor: "#ccc",
                      borderRadius: 6,
                      padding: 10,
                      marginBottom: 10,
                    }}
                  />
                  <TextInput
                    placeholder="Nova senha"
                    secureTextEntry
                    value={novaSenha}
                    onChangeText={setNovaSenha}
                    style={{
                      borderWidth: 1,
                      borderColor: "#ccc",
                      borderRadius: 6,
                      padding: 10,
                      marginBottom: 10,
                    }}
                  />
                  <TextInput
                    placeholder="Confirmar nova senha"
                    secureTextEntry
                    value={confirmarSenha}
                    onChangeText={setConfirmarSenha}
                    style={{
                      borderWidth: 1,
                      borderColor: "#ccc",
                      borderRadius: 6,
                      padding: 10,
                      marginBottom: 10,
                    }}
                  />

                  <TouchableOpacity
                    onPress={atualizarSenha}
                    style={{
                      backgroundColor: "#730d83",
                      padding: 12,
                      borderRadius: 6,
                      alignItems: "center",
                      marginBottom: 10,
                    }}
                  >
                    <Text style={{ color: "#fff", fontWeight: "bold" }}>
                      Salvar Senha
                    </Text>
                  </TouchableOpacity>
                  <TouchableOpacity
                    onPress={fecharModais}
                    style={{ alignItems: "center" }}
                  >
                    <Text style={{ color: "#aaa" }}>Cancelar</Text>
                  </TouchableOpacity>
                  {mensagemSenha ? (
                    <Text style={{ marginTop: 10, color: "green" }}>
                      {mensagemSenha}
                    </Text>
                  ) : null}
                </View>
              </View>
            </Modal>

            {/* Loading */}
            {loading && (
              <Modal transparent>
                <View
                  style={{
                    flex: 1,
                    backgroundColor: "rgba(0,0,0,0.5)",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <ActivityIndicator size="large" color="#fff" />
                </View>
              </Modal>
            )}
          </ScrollView>
        );
      }}
    </BaseWeb>
  );
}
